/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */
import { useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from "@tanstack/react-query";

import axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";

import type {
    PageState,
    PageStateDataToMigrate,
    ShareableLinkId,
    ShareableLinkView,
} from "../model";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

const withQueryKey = <T extends object, K>(
    query: T,
    queryKey: K
): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };
    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === "queryKey") continue;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }
    return result;
};

export const getShareableLinksId = (
    id: ShareableLinkId,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ShareableLinkView>> => {
    return axios.get(`/api/shareable-links/${id}`, options);
};

export const getGetShareableLinksIdQueryKey = (id: ShareableLinkId) => {
    return [`/api/shareable-links/${id}`] as const;
};

export const getGetShareableLinksIdQueryOptions = <
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetShareableLinksIdQueryKey(id);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getShareableLinksId>>
    > = ({ signal }) => getShareableLinksId(id, { signal, ...axiosOptions });

    return {
        queryKey,
        queryFn,
        enabled: id !== null && id !== undefined,
        ...queryOptions,
    } as UseQueryOptions<
        Awaited<ReturnType<typeof getShareableLinksId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetShareableLinksIdQueryResult = NonNullable<
    Awaited<ReturnType<typeof getShareableLinksId>>
>;
export type GetShareableLinksIdQueryError = AxiosError<unknown>;

export function useGetShareableLinksId<
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options: {
        query: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getShareableLinksId>>,
                    TError,
                    Awaited<ReturnType<typeof getShareableLinksId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetShareableLinksId<
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof getShareableLinksId>>,
                    TError,
                    Awaited<ReturnType<typeof getShareableLinksId>>
                >,
                "initialData"
            >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetShareableLinksId<
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetShareableLinksId<
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetShareableLinksIdQueryOptions(id, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<
        TData,
        TError
    > & { queryKey: DataTag<QueryKey, TData, TError> };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getGetShareableLinksIdSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    }
) => {
    const { query: queryOptions, axios: axiosOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getGetShareableLinksIdQueryKey(id);

    const queryFn: QueryFunction<
        Awaited<ReturnType<typeof getShareableLinksId>>
    > = ({ signal }) => getShareableLinksId(id, { signal, ...axiosOptions });

    return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getShareableLinksId>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetShareableLinksIdSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof getShareableLinksId>>
>;
export type GetShareableLinksIdSuspenseQueryError = AxiosError<unknown>;

export function useGetShareableLinksIdSuspense<
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options: {
        query: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetShareableLinksIdSuspense<
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetShareableLinksIdSuspense<
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetShareableLinksIdSuspense<
    TData = Awaited<ReturnType<typeof getShareableLinksId>>,
    TError = AxiosError<unknown>,
>(
    id: ShareableLinkId,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof getShareableLinksId>>,
                TError,
                TData
            >
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
} {
    const queryOptions = getGetShareableLinksIdSuspenseQueryOptions(
        id,
        options
    );

    const query = useSuspenseQuery(
        queryOptions,
        queryClient
    ) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const postShareableLinks = (
    pageState: PageState,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<ShareableLinkView>> => {
    return axios.post(`/api/shareable-links`, pageState, options);
};

export const getPostShareableLinksMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postShareableLinks>>,
        TError,
        { data: PageState },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postShareableLinks>>,
    TError,
    { data: PageState },
    TContext
> => {
    const mutationKey = ["postShareableLinks"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postShareableLinks>>,
        { data: PageState }
    > = (props) => {
        const { data } = props ?? {};

        return postShareableLinks(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostShareableLinksMutationResult = NonNullable<
    Awaited<ReturnType<typeof postShareableLinks>>
>;
export type PostShareableLinksMutationBody = PageState;
export type PostShareableLinksMutationError = AxiosError<unknown>;

export const usePostShareableLinks = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postShareableLinks>>,
            TError,
            { data: PageState },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postShareableLinks>>,
    TError,
    { data: PageState },
    TContext
> => {
    return useMutation(
        getPostShareableLinksMutationOptions(options),
        queryClient
    );
};
export const postShareableLinksMigrate = (
    pageStateDataToMigrate: PageStateDataToMigrate,
    options?: AxiosRequestConfig
): Promise<AxiosResponse<PageState>> => {
    return axios.post(
        `/api/shareable-links/migrate`,
        pageStateDataToMigrate,
        options
    );
};

export const getPostShareableLinksMigrateMutationOptions = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof postShareableLinksMigrate>>,
        TError,
        { data: PageStateDataToMigrate },
        TContext
    >;
    axios?: AxiosRequestConfig;
}): UseMutationOptions<
    Awaited<ReturnType<typeof postShareableLinksMigrate>>,
    TError,
    { data: PageStateDataToMigrate },
    TContext
> => {
    const mutationKey = ["postShareableLinksMigrate"];
    const { mutation: mutationOptions, axios: axiosOptions } = options
        ? options.mutation &&
          "mutationKey" in options.mutation &&
          options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, axios: undefined };

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof postShareableLinksMigrate>>,
        { data: PageStateDataToMigrate }
    > = (props) => {
        const { data } = props ?? {};

        return postShareableLinksMigrate(data, axiosOptions);
    };

    return { mutationFn, ...mutationOptions };
};

export type PostShareableLinksMigrateMutationResult = NonNullable<
    Awaited<ReturnType<typeof postShareableLinksMigrate>>
>;
export type PostShareableLinksMigrateMutationBody = PageStateDataToMigrate;
export type PostShareableLinksMigrateMutationError = AxiosError<unknown>;

export const usePostShareableLinksMigrate = <
    TError = AxiosError<unknown>,
    TContext = unknown,
>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<typeof postShareableLinksMigrate>>,
            TError,
            { data: PageStateDataToMigrate },
            TContext
        >;
        axios?: AxiosRequestConfig;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<typeof postShareableLinksMigrate>>,
    TError,
    { data: PageStateDataToMigrate },
    TContext
> => {
    return useMutation(
        getPostShareableLinksMigrateMutationOptions(options),
        queryClient
    );
};
